import React from "react";
import { Card } from "@mui/material";
import CardBody from "../../../../components/Card/CardBody";
import MenuSyncSettings from "../MenuSyncSettings";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import AutoSyncSwitch from "./PosSyncs/AutoSyncSwitch";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import { useFormContext } from "react-hook-form";
import FormJson from "../../../../components/Forms/FormJson";

function CustomData() {
  const { menukaartVestigingId } = useFormContext();
  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <FormJson
            name={"custom_data"}
            tDefault={"JSON Data"}
            tKey={"vestigingen.form.defaultsettings.headers.json"}
          />
        </CardBody>
      </Card>
    </div>
  );
}

export default CustomData;
